"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const ScrollWrapper = styled_components_1.default.div `
  overflow: auto;
  max-height: ${({ theme }) => theme.dropdownMaxHeight};
  max-width: ${({ theme }) => theme.dropdownMaxWidth};
  min-width: 120px;
`;
ScrollWrapper.displayName = 'ScrollWrapper';
exports.default = ScrollWrapper;
